module.exports = __webpack_public_path__ + "static/clientFannyWautelet-43fc146c1f5301608776f62b9c2c2616.jpg";